module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('form', [_c('website', {
    ref: "website"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('div', {
    staticClass: "rte"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-width"
  }, [_c('DataTable', {
    ref: "dt",
    attrs: {
      "value": _vm.products,
      "dataKey": "id",
      "paginator": true,
      "rows": 10,
      "filters": _vm.filters,
      "paginatorTemplate": "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      "rowsPerPageOptions": [5, 10, 25],
      "currentPageReportTemplate": "Showing {first} to {last} of {totalRecords} products"
    }
  }, [_c('Column', {
    attrs: {
      "header": "Image"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('img', {
          staticClass: "product-image",
          attrs: {
            "src": 'demo/images/product/' + slotProps.data.image,
            "alt": slotProps.data.image
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "code",
      "header": "Product",
      "sortable": ""
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "name",
      "header": "Price",
      "sortable": ""
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "price",
      "header": "Price",
      "sortable": ""
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "category",
      "header": "Quantity",
      "sortable": ""
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "field": "rating",
      "header": "Total",
      "sortable": ""
    }
  }), _vm._v(" "), _c('Column', {
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-success p-mr-2",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editProduct(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-warning",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDeleteProduct(slotProps.data)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "cart__footer"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "solid-border"
  }, [_c('h5', [_c('label', {
    staticClass: "cart-note__label small--text-center"
  }, [_vm._v("\n                      Add a note to your order\n                    ")]), _vm._v(" "), _c('Textarea', {
    attrs: {
      "rows": "8",
      "cols": "60"
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "solid-border"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('span', {
    staticClass: "grid__item one-half cart__subtotal-title"
  }, [_vm._v("\nSUBTOTAL\n            ")]), _vm._v(" "), _c('span', {
    staticClass: "grid__item one-half cart__subtotal text-right"
  }, [_vm._v("\n                " + _vm._s(333333) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "cart__shipping"
  }, [_vm._v("\n                      Shipping & taxes calculated at checkout\n                    ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn btn--small-wide checkout",
    staticStyle: {
      "border": "0px solid #eceff1"
    },
    attrs: {
      "label": "CHECKOUT"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('cart')
      }
    }
  })], 1)])])])], 1)])]), _vm._v(" "), _c('footerWebsite', {
    ref: "footerWebsite"
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page section-header text-center"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("Your Cart")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ebcc5ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/ecommerce/cart.vue
// module id = 2221
// module chunks = 0